'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('../../blocks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Checkbox(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      readOnly = _ref.readOnly,
      rest = _objectWithoutProperties(_ref, ['checked', 'disabled', 'id', 'label', 'onChange', 'onClick', 'readOnly']);

  return _react2.default.createElement(
    _blocks.Checkbox,
    {
      modifiers: (0, _lodash.compact)([disabled && 'disabled', readOnly && 'readOnly'])
    },
    _react2.default.createElement(_blocks.Checkbox.Input, _extends({}, rest, {
      checked: checked,
      disabled: disabled,
      id: id,
      onChange: !disabled && !readOnly ? onChange : _lodash.noop,
      onClick: !disabled && !readOnly ? onClick : _lodash.noop,
      readOnly: readOnly
    })),
    _react2.default.createElement(
      _blocks.Checkbox.Label,
      {
        htmlFor: id,
        modifiers: (0, _lodash.compact)([label && 'withContent'])
      },
      label
    )
  );
}

Checkbox.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  id: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  readOnly: _propTypes2.default.bool
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  label: undefined,
  onChange: _lodash.noop,
  onClick: _lodash.noop,
  readOnly: false
};

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Checkbox/index.js
// module id = 1627
// module chunks = 2